module.exports = __webpack_public_path__ + "static/scale-model-of-visit-tallahassee-in-tallahassee-florida-1986fdbbc6f04ef93247dd17f59d99ac.png";